import { Box, Grid, Typography } from "@material-ui/core";
import RefundVenueSettingsForm from "./refundVenueSettingsForm";

export default function RefundVenueSettingsEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Refund &gt; Edit Venue
        </Typography>
      </Box>
      <Grid container xs={6}>
        <RefundVenueSettingsForm
          description="Edit Venue"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
